import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { greenDefault } from 'app/components/ThemeProvider/colors';

const PlusIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M11.0002 4.58301V17.4163M4.5835 10.9997H17.4168"
        stroke={props.color === 'secondary' ? greenDefault : props.color === 'info' ? 'black' : 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default PlusIcon;
